<button
  *ngIf="type === 'primary'"
  (click)="sendMessage()"
  data-action="clicked-start-chat"
  mat-flat-button
  color="primary"
  [disabled]="creatingConversation$ | async"
>
  <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</button>

<button
  *ngIf="type === 'secondary'"
  (click)="sendMessage()"
  data-action="clicked-start-chat"
  mat-flat-button
  [disabled]="creatingConversation$ | async"
>
  <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</button>

<button
  *ngIf="type === 'alternative'"
  (click)="sendMessage()"
  data-action="clicked-start-chat"
  mat-stroked-button
  color="primary"
  class="remove-border"
  [disabled]="creatingConversation$ | async"
>
  <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</button>

<button
  *ngIf="type === 'text'"
  (click)="sendMessage()"
  data-action="clicked-start-chat"
  mat-stroked-button
  color="primary"
  class="remove-border"
  [disabled]="creatingConversation$ | async"
>
  <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</button>

<a *ngIf="type === 'link'" (click)="sendMessage()" data-action="clicked-start-chat">
  <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</a>

<button
  *ngIf="type === 'menu'"
  (click)="sendMessage()"
  data-action="clicked-start-chat"
  mat-menu-item
  [disabled]="creatingConversation$ | async"
>
  <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
</button>

<button
  *ngIf="type === 'icon'"
  (click)="sendMessage()"
  data-action="clicked-start-chat"
  mat-icon-button
  color="primary"
  class="remove-border"
  [disabled]="creatingConversation$ | async"
  matTooltip="{{ 'INBOX.CHAT.SEND_MESSAGE' | translate }}"
>
  <mat-icon>forum</mat-icon>
</button>

<ng-template #buttonContent>
  <div class="row">
    <mat-icon class="icon-style" [ngClass]="{ 'icon-color': primaryIcon }">forum</mat-icon>
    <glxy-button-loading-indicator [isLoading]="creatingConversation$ | async">
      <span #content>
        <ng-content></ng-content>
      </span>
      <span *ngIf="content.childNodes.length === 0">
        {{ 'INBOX.CHAT.SEND_MESSAGE' | translate }}
      </span>
    </glxy-button-loading-indicator>
  </div>
</ng-template>
